import { Button, Checkbox, Col, Row, Select, Typography } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import "./style.css";
import {
  getListTypeQuestionAPI,
  getListExamMaterialsURL,
  getListOfQuestionURL,
  postSubmitIsmsURL,
  getResultISMSAPI,
} from "api/ismsApi";
import undraw_security from "../../images/undraw_security.svg";
import CryptoJS from "crypto-js";
import ShowImageISMS from "./Isms/ShowImageISMS";
import { openNotificationWithIcon } from "containers/Function";
import ShowAnswerSheet from "./Isms/ShowAnswerSheet";
import ShowModalComfirmSubmit from "./Isms/ShowModalComfirmSubmit";
import { SearchOutlined } from "@ant-design/icons";
import ModalViewResultISMS from "./ModalViewResultISMS";

const { Title } = Typography;
const secretKey = "X9fL2qWm7BzK8dV1aErYpT0hJuNc6MsQ3ZgCoRxLtvbHnFUdYj";

const ThiISMS = () => {
  const userInfo = useSelector((state) => state?.getUserInfo.userInfo);
  const [isCheckbox, setIsCheckbox] = useState(false);
  const [loading, setLoading] = useState(true);
  const [listTypeQuestion, setListTypeQuestion] = useState([]);
  const [listBinaryImage, setListBinaryImage] = useState([]);
  const [isCheckExam, setIsCheckExam] = useState(undefined);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [listOfQuestion, setListOfQuestion] = useState(undefined);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState([]);
  const [dataSuccess, setDataSuccess] = useState(undefined);
  const [remainingTime, setRemainingTime] = useState(undefined);
  const [isCheckShowModalConfirm, setIsCheckShowModalConfirm] = useState(false);
  const [questionComplete, setQuestionComplete] = useState(0);
  const [isShowViewResult, setIsShowViewResult] = useState(false);
  const [ listResultExam, setListResultExam ] = useState([])
  const timerRef = useRef(null);

  const onChangeCheckbox = (e) => {
    setIsCheckbox(e.target.checked);
  };

  const handleChangeExam = (e) => {
    setIsCheckExam(e);
    setCurrentIndex(0);
    setListBinaryImage([]);
    setIsCheckbox(false);
    setDataSuccess(undefined);
  };

  const fetchListTypeQuestion = () => {
    getListTypeQuestionAPI()
      .then((res) => {
        res.data.results.sort(
          (a, b) => parseInt(a.loai_cau_hoi) - parseInt(b.loai_cau_hoi)
        );
        setListTypeQuestion(res.data.results);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const decryptData = (encrypted, secretKey) => {
    const key = CryptoJS.SHA256(secretKey);
    const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText);
  };

  const fetchListOfQuestion = () => {
    getListOfQuestionURL({
      id_set_exam: isCheckExam.value, //id đợt thi
      user_id: userInfo.id,
    })
      .then((res) => {
        if (res.data.code === "CODE_001" || res.data.code === "CODE_002") {
          setDataSuccess(res.data);
        } else {
          const result = decryptData(res.data.encrypted_data, secretKey);
          setListOfQuestion(result);
          setDataSuccess(undefined);
          const initialAnswers = result.results.map((q) => ({
            id: q.id.toString(),
            dap_an: "",
            dap_an_dung: q.dap_an_dung.toString(),
            is_check: false,
          }));

          setUserAnswers(initialAnswers);
          setLoading(false);

          // Dọn timer cũ nếu có
          if (timerRef.current) clearInterval(timerRef.current);

          // Tạo timer mới
          timerRef.current = setInterval(() => {
            setRemainingTime((prev) => {
              if (prev <= 1) {
                clearInterval(timerRef.current);
                timerRef.current = null;
                // Gọi hàm nộp bài hoặc hiển thị kết thúc
                return 0;
              }
              return prev - 1;
            });
          }, 1000);
          setRemainingTime(Number(result.thoi_gian_thi) * 60); // Giây
        }
      })
      .catch((err) => {
        openNotificationWithIcon("error", "Lỗi", err.data.error);
        setLoading(false);
      });
  };

  const handleClickSubmitGetExam = () => {
    fetchListOfQuestion();
  };

  const fetchListExamMaterials = useCallback(() => {
    fetchListTypeQuestion();
    getListExamMaterialsURL({ question_type: isCheckExam.key })
      .then((res) => {
        setListBinaryImage(res.data.results);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [isCheckExam]);

  const handleSelectAnswer = (questionIndex, answerIndex) => {
    const currentQuestion = listOfQuestion.results[questionIndex];
    const questionId = currentQuestion.id.toString();
    const selectedAnswer = (answerIndex + 1).toString(); // chỉ số đáp án tính từ 1

    var updatedAnswers;
    const existing = userAnswers.find((a) => a.id === questionId);
    const correctAnswer = currentQuestion.dap_an_dung.toString();
    if (existing) {
      const selectedList = existing.dap_an ? existing.dap_an.split("+") : [];
      const alreadySelected = selectedList.includes(selectedAnswer);
      const updatedList = alreadySelected
        ? selectedList.filter((item) => item !== selectedAnswer)
        : [...selectedList, selectedAnswer];

      if (updatedList.length === 0) {
        // Nếu không còn đáp án nào thì xoá khỏi danh sách
        updatedAnswers = userAnswers.filter((a) => a.id !== questionId);
      } else {
        const newDapAn = updatedList.sort().join("+");
        const isCorrect = newDapAn === correctAnswer;
        updatedAnswers = userAnswers.map((a) =>
          a.id === questionId
            ? {
                ...a,
                dap_an: newDapAn,
                is_check: isCorrect,
              }
            : a
        );
      }
    } else {
      const isCorrect = selectedAnswer === correctAnswer;
      updatedAnswers = [
        ...userAnswers,
        {
          id: questionId,
          dap_an: selectedAnswer,
          dap_an_dung: correctAnswer,
          is_check: isCorrect,
        },
      ];
    }
    // Cập nhật % câu hỏi đã có trả lời
    setQuestionComplete(
      updatedAnswers.filter((item) => item.dap_an != "").length
    );

    setUserAnswers(updatedAnswers);
  };

  const handleClickShowModalSubmit = () => {
    setIsCheckShowModalConfirm(true);
  };

  function pad(text) {
    const blockSize = 16;
    const padLength = blockSize - (text.length % blockSize);
    const padding = String.fromCharCode(padLength).repeat(padLength);
    return text + padding;
  }

  function encryptAES(data, secretKey) {
    const jsonString = JSON.stringify(data);
    const padded = pad(jsonString);

    // Hash secret key bằng SHA256 giống backend
    const key = CryptoJS.SHA256(secretKey);

    // AES ECB mode
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(padded),
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.NoPadding, // Vì đã pad thủ công rồi
      }
    );

    return encrypted.toString(); // base64 string
  }
  const handleSubmitExam = useCallback(() => {
    setIsCheckShowModalConfirm(false);

    const rawData = {
      user_id: userInfo.id,
      id_set_exam: isCheckExam.value,
      thoi_gian_thi: `${Math.floor(remainingTime / 60)}/${
        listOfQuestion.thoi_gian_thi
      }`,
      results: userAnswers,
      list_plan: userInfo.username,
    };

    const encryptedData = encryptAES(rawData, secretKey);

    postSubmitIsmsURL({ encrypted_data: encryptedData })
      .then((res) => {
        setIsCheckbox(false);
        setCurrentQuestionIndex(0);
        setDataSuccess(res.data);
        setRemainingTime(undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [isCheckExam, userAnswers, userInfo, listOfQuestion, remainingTime]);

  const handleClickBack = () => {
    setDataSuccess(undefined);
    setIsCheckbox(false);
    setCurrentIndex(0);
    setListOfQuestion(undefined);
    setCurrentQuestionIndex(0);
  };

  useEffect(() => {
    if (isCheckExam !== undefined) {
      fetchListExamMaterials();
    }
  }, [isCheckExam, fetchListExamMaterials]);

  useEffect(() => {
    fetchListTypeQuestion();
  }, []);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (remainingTime === 0) {
      handleSubmitExam();
      return;
    }
    const timer = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [remainingTime, handleSubmitExam]);

  const handleOnCancel = () => {
    setIsCheckShowModalConfirm(false);
  };

  const onCancelResultISMS = () => {
    setIsShowViewResult(false);
  };

  const handlSearch = () => {
    setIsShowViewResult(true);

    getResultISMSAPI({ user_exam_id: dataSuccess.user_exam_id })
      .then((res) => {
        const result = decryptData(res.data.encrypted_data, secretKey)
        setListResultExam(result);

      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Row className="disable-copy">
      <Col span={18}>
        {dataSuccess === undefined ? (
          <>
            {listOfQuestion !== undefined ? (
              <ShowAnswerSheet
                currentQuestionIndex={currentQuestionIndex}
                setCurrentQuestionIndex={setCurrentQuestionIndex}
                listOfQuestion={listOfQuestion}
                userAnswers={userAnswers}
                handleSelectAnswer={handleSelectAnswer}
                remainingTime={remainingTime}
                questionComplete={questionComplete}
              />
            ) : (
              <ShowImageISMS
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                listBinaryImage={listBinaryImage}
                undraw_security={undraw_security}
                typeSize={"large"} // 'middle' | 'large' | undefined
                messagePage={
                  "Chưa có dữ liệu câu hỏi. Vui lòng chọn nhóm thi để bắt đầu."
                }
              />
            )}
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh", // hoặc 100vh nếu full màn hình
            }}
          >
            <div
              style={{
                backgroundColor: "#f5f5f5",
                padding: "30px 40px",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",

                minWidth: 300,
              }}
            >
              <h2
                style={{
                  fontWeight: "700",
                  fontSize: 24,
                  color: "#333",
                  textAlign: "center",
                }}
              >
                🎉 KẾT QUẢ
              </h2>
              <p style={{ fontSize: 16, marginTop: 12 }}>
                ✅ <strong>Câu đúng:</strong> {dataSuccess.diem_thi}
              </p>
              <p style={{ fontSize: 16 }}>
                ⭐ <strong>Điểm:</strong> {dataSuccess.diem_thi_quy_doi}
              </p>
              <p style={{ fontSize: 16 }}>
                🕐 <strong>Thời gian nộp bài thi:</strong>{" "}
                {dataSuccess.ngay_thi}
              </p>
              <p
                style={
                  dataSuccess.code === "CODE_001"
                    ? { fontSize: 16, marginTop: 16, color: "#28a745" }
                    : { fontSize: 16, marginTop: 16, color: "red" }
                }
              >
                🏆 <strong>{dataSuccess.message}</strong>
              </p>

              <Button
                // onClick={reloadLog}
                type="primary"
                icon={<SearchOutlined />}
                style={{ marginLeft: "5px" }}
                className="btn-gradient"
                onClick={handlSearch}
              >
                Kết quả bài thi
              </Button>
            </div>
          </div>
        )}
      </Col>

      <Col
        span={6}
        style={{
          borderLeft: "1px solid #ccc",
          paddingLeft: 20,
          height: "80vh",
        }}
      >
        <Row>
          <Col span={24}>
            <Title level={2} className="custom-title">
              BÀI KIỂM TRA ISMS
            </Title>
          </Col>
          <Col span={24} style={{ paddingBottom: 15 }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  fontSize: 15,
                  color: "#e76f51",
                  fontWeight: 600,
                  paddingRight: 5,
                }}
              >
                Thông Tin Nhân Viên
              </span>
              <div style={{ flex: 1, height: 1, backgroundColor: "#ccc" }} />
            </div>
          </Col>
          <Col span={24} style={{ paddingLeft: 10 }}>
            <p style={{ fontSize: 15, paddingRight: 20 }}>
              Họ và tên:{" "}
              <span style={{ fontWeight: 600 }}>{userInfo?.first_name}</span>
            </p>
          </Col>
          <Col span={24} style={{ paddingLeft: 10 }}>
            <p style={{ fontSize: 15, paddingRight: 20 }}>
              MSNV:{" "}
              <span style={{ fontWeight: 600 }}>
                {userInfo?.data_customer?.name_abbreviation}
                {userInfo?.msnv}
              </span>
            </p>
          </Col>
          <Col span={24} style={{ paddingLeft: 10 }}>
            <p style={{ fontSize: 15, paddingRight: 20 }}>
              Username:{" "}
              <span style={{ fontWeight: 600 }}>{userInfo?.username}</span>
            </p>
          </Col>
          <Col span={24} style={{ paddingLeft: 10 }}>
            <p style={{ fontSize: 15, paddingRight: 20 }}>
              Team:{" "}
              <span style={{ fontWeight: 600 }}>{userInfo?.team_name}</span>
            </p>
          </Col>
          <Col span={24} style={{ paddingBottom: 10 }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  fontSize: 15,
                  color: "#e76f51",
                  fontWeight: 600,
                  paddingRight: 5,
                }}
              >
                Nhóm thi
              </span>
              <div style={{ flex: 1, height: 1, backgroundColor: "#ccc" }} />
            </div>
          </Col>
          <Col span={24} style={{ paddingLeft: 10 }}>
            <Select
              size="large"
              className="thi-isms-select"
              placeholder="Vui lòng chọn nhóm thi"
              onChange={handleChangeExam}
              labelInValue
              disabled={listOfQuestion === undefined ? false : true}
            >
              {listTypeQuestion.map((e) => (
                <Select.Option key={e.loai_cau_hoi} value={e.id_set_exam}>
                  {e.fullname_question?.toUpperCase()}
                </Select.Option>
              ))}
            </Select>
          </Col>

          {isCheckExam !== undefined && (
            <>
              <Col span={12} style={{ paddingLeft: 10 }}>
                <p style={{ fontSize: 15, paddingRight: 20 }}>
                  Thời gian thi:{" "}
                  <span style={{ fontWeight: 600 }}>
                    {listTypeQuestion &&
                      listTypeQuestion.filter(
                        (item) =>
                          item.loai_cau_hoi.toString() ==
                          isCheckExam.key.toString()
                      )?.[0]?.thoi_gian_thi}{" "}
                    Phút
                  </span>
                </p>
              </Col>
              <Col span={12} style={{ paddingLeft: 10 }}>
                <p style={{ fontSize: 15, paddingRight: 20 }}>
                  Số lần thi:{" "}
                  <span style={{ fontWeight: 600 }}>
                    {listTypeQuestion &&
                      listTypeQuestion.filter(
                        (item) =>
                          item.loai_cau_hoi.toString() ==
                          isCheckExam.key.toString()
                      )?.[0]?.number_retakes}
                  </span>
                </p>
              </Col>
              <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      fontSize: 15,
                      color: "#e76f51",
                      fontWeight: 600,
                      paddingRight: 5,
                    }}
                  ></span>
                  <div
                    style={{ flex: 1, height: 1, backgroundColor: "#ccc" }}
                  />
                </div>
              </Col>
              {listOfQuestion === undefined && dataSuccess === undefined && (
                <Col span={24} style={{ paddingTop: 10 }}>
                  <Checkbox onChange={onChangeCheckbox} checked={isCheckbox}>
                    <p
                      style={{
                        fontSize: 15,
                        marginBottom: 5,
                      }}
                    >
                      Tôi đã đọc tài liệu ISMS
                    </p>
                  </Checkbox>
                </Col>
              )}
              <Col span={24} style={{ paddingBottom: 10 }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {dataSuccess === undefined ? (
                    <>
                      {listOfQuestion === undefined ? (
                        <Button
                          type="primary"
                          onClick={handleClickSubmitGetExam}
                          disabled={!isCheckbox}
                          className="btn-start"
                        >
                          Bắt đầu làm bài thi
                        </Button>
                      ) : (
                        <Button
                          type="primary"
                          onClick={handleClickShowModalSubmit}
                          className="btn-start"
                          style={{ marginTop: 10 }}
                        >
                          Hoàn thành bài thi
                        </Button>
                      )}
                    </>
                  ) : (
                    <Button
                      type="primary"
                      onClick={handleClickBack}
                      className="btn-start"
                      style={{ marginTop: 10 }}
                    >
                      Quay lại
                    </Button>
                  )}
                </div>
              </Col>
            </>
          )}
        </Row>
      </Col>

      {isCheckShowModalConfirm && (
        <ShowModalComfirmSubmit
          isCheckShowModalConfirm={isCheckShowModalConfirm}
          handleSubmitExam={handleSubmitExam}
          handleOnCancel={handleOnCancel}
        />
      )}

      {isShowViewResult && (
        <ModalViewResultISMS
          open={isShowViewResult}
          onCancel={onCancelResultISMS}
          dataSuccess={dataSuccess}
          listResultExam={listResultExam}
        />
      )}
    </Row>
  );
};

export default ThiISMS;
